import { cleanersTypes } from "../ActionTypes/CleanersTypes";

let initialSate = {
 activeCleaners : [],
 activeCleanersPagination : null
};

const activeCleanersReducer = (state = initialSate, action) => {
    switch (action.type) {

        case cleanersTypes.GET_ACTIVE_CLEANERS:
            let activeCleaners_Copy = [];
            activeCleaners_Copy = [
                ...state.activeCleaners,
                ...action.payload.data,
            ];      
            state = { 
                ...state, 
                activeCleanersPagination: action.payload, 
                activeCleaners: activeCleaners_Copy  
            };    
            break;
        
            case cleanersTypes.CLEAR_ACTIVE_CLEANERS:
                state = {
                    activeCleaners: [],
                    activeCleanersPagination: null
                }
                break;
    }
    return state;
};

export default activeCleanersReducer;
